import { useEffect, RefObject } from 'react';

/**
 *  This function is a custom hook to add "click outside" handling i.e. to close a modal when clicking outside the modal.
 *  It can only be used at the top level of a React functional component.
 *
 * @param ref - ref of the "inside"; prevents clicks inside from closing
 * @param isActive - variable that controls when clickOutside event listener is on
 * @param handleClick - the function to call when clicking outside occurs
 *
 **/

const useClickOutside = (ref: RefObject<HTMLElement | null>, isActive: boolean, handleClick: (e: MouseEvent) => any): void => {
  const handleClickOutside = (e: MouseEvent) => {
    const target = e.target as Node;
    const inside = ref.current;
    if (inside && target !== inside && !inside?.contains(target)) {
      handleClick(e);
    }
  };

  useEffect(() => {
    if (isActive) {
      document.addEventListener('click', handleClickOutside);
    }
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isActive]);
};

export default useClickOutside;
